module.exports = __webpack_public_path__ + "img/nearsightedness.0659a83.jpg?v=1747398688961";